"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var MemoryStorage = (function () {
    function MemoryStorage() {
        this._memoryStorage = {};
    }
    MemoryStorage.prototype.length = function () {
        return Object.keys(this._memoryStorage).length;
    };
    MemoryStorage.prototype.getItem = function (key) {
        return this._memoryStorage[key];
    };
    MemoryStorage.prototype.setItem = function (key, data) {
        if (!key) {
            return;
        }
        this._memoryStorage[key] = data;
        return data;
    };
    MemoryStorage.prototype.removeItem = function (key) {
        if (!key || !this._memoryStorage[key]) {
            return;
        }
        this._memoryStorage[key] = undefined;
    };
    MemoryStorage.prototype.clear = function () {
        this._memoryStorage = {};
    };
    MemoryStorage.prototype.key = function (_) {
        console.warn("[".concat(constants_1.logPrefix, "] unsupported method, please use getItem(key) instead."));
        return 'N/A';
    };
    return MemoryStorage;
}());
exports.default = MemoryStorage;
//# sourceMappingURL=memoryStorage.js.map